import React from "react";

import { PageDataLayer, tracking } from "../../app/services/tracking";
import { Container } from "../../features/shared/Container";
import { Head } from "../../features/shared/Head";
import { Button } from "../../features/shared/Button";
import { ReactComponent as AddContractsIcon } from "../../features/core/AccountNavAddContractsIcon.svg";
import { router } from "../../app/services/router";

const classNamePrefix = "MainPage";

type MainPageProps = {
  about?: React.ReactNode;
  children: React.ReactNode;
  dataLayer?: PageDataLayer;
  icon?: React.ReactNode;
  meta?: { title: string };
  title: React.ReactNode;
  brandLogo?: React.ReactNode;
  addContract?: React.ReactNode;
};

export const MainPage = (props: MainPageProps) => {
  const {
    about,
    children,
    dataLayer,
    icon,
    meta,
    title,
    brandLogo,
    addContract,
  } = props;

  React.useEffect(() => {
    if (dataLayer) {
      tracking.trackPage(dataLayer);
    }
  }, [dataLayer]);

  const mainAddContracts = {
    eventLabel: "ajouter_un_contrat",
    icon: <AddContractsIcon />,
  };

  return (
    <>
      {meta && <Head {...meta} />}
      <div className={classNamePrefix}>
        <Container className={`${classNamePrefix}-header`}>
          <div className={`${classNamePrefix}-header-content`}>
            <h1 className={`${classNamePrefix}-title`}>
              {icon}
              {title}
            </h1>
            <div className={`${classNamePrefix}-action`}>
              {addContract && (
                <Button
                  onClick={() => {
                    tracking.trackEvent({
                      eventAction: "clic",
                      eventCategory: "ajout_contrat",
                      eventLabel: mainAddContracts.eventLabel,
                    });
                    window.location.href = router.getTo("mainAddContracts");
                  }}
                  variant="action"
                >
                  {mainAddContracts.icon}
                  {addContract}
                </Button>
              )}
            </div>
          </div>
          <div className={`${classNamePrefix}-main-data`}>
            {about && <div className={`${classNamePrefix}-about`}>{about}</div>}
            {brandLogo && (
              <div className={`${classNamePrefix}-brand`}>{brandLogo}</div>
            )}
          </div>
        </Container>
        {children}
      </div>
    </>
  );
};
